export default {
    header: "Sei stato disconnesso con successo",
    message: ""
}